import { Button } from '@material-ui/core';
import React, { useState } from 'react';
import 'assets/scss/multi-content.scss';
type MultiContentProps = {
	title: string;
	subtitle?: string;
	optionsTitle: string[];
	selectedContent: any[];
	backgroundColor?: string;
};

export const MultiContent = ({
	title,
	subtitle,
	optionsTitle,
	selectedContent,
	backgroundColor,
}: MultiContentProps) => {
	const [optionSelect, setOptionSelect] = useState(0);
	return (
		<div
			className="multi-content-container"
			style={{
				backgroundColor: backgroundColor || 'transparent',
			}}
		>
			<h1
				className="title-3 primary-color"
				style={{
					textAlign: 'center',
					marginBottom: 32,
				}}
			>
				{title}
			</h1>
			{subtitle ? (
				<h2
					className="body negro-general"
					style={{
						textAlign: 'center',
						marginBottom: 32,
					}}
				>
					{subtitle}
				</h2>
			) : null}
			<div className="multicontent-option-container">
				{optionsTitle.map((value, index) => {
					return (
						<div key={`${index}_option`} className="multicontent-option-item">
							<Button
								variant="contained"
								disableElevation
								disableRipple
								style={{
									backgroundColor: optionSelect !== index ? 'white' : '',
									color: optionSelect !== index ? '#004e9c' : '',
									fontWeight: optionSelect !== index ? 'normal' : 'bold',
								}}
								color={optionSelect === index ? 'primary' : 'default'}
								onClick={() => setOptionSelect(index)}
							>
								{value}
							</Button>
							{optionSelect === index ? (
								<div className="muticontent-option-select-triangle"></div>
							) : null}
						</div>
					);
				})}
			</div>
			<div className="multicontent-selectContent">{selectedContent[optionSelect]}</div>
		</div>
	);
};
